import { useState } from "react";

const REASON_OPTIONS = [
  { value: "language_quality", label: "Sounds unnatural" },
  { value: "hallucination", label: "Wrong facts" },
  { value: "tone", label: "Wrong tone" },
  { value: "conversational_quality", label: "Didn't answer the question" },
  { value: "relevance", label: "Not relevant" },
  { value: "business_logic", label: "Business logic issue" },
  { value: "other", label: "Other" },
];

type DraftFeedbackModalProps = {
  open: boolean;
  onClose: () => void;
  onSubmit: (reasonCategory: string, feedbackText: string) => void;
  isSubmitting?: boolean;
};

export const DraftFeedbackModal = ({
  open,
  onClose,
  onSubmit,
  isSubmitting = false,
}: DraftFeedbackModalProps) => {
  const [reason, setReason] = useState("");
  const [comments, setComments] = useState("");

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="draft-feedback-title"
    >
      <div className="w-full max-w-md rounded-xl border border-slate-200 bg-white p-5 shadow-lg">
        <h2
          id="draft-feedback-title"
          className="text-lg font-semibold text-slate-900"
        >
          Tell us more
        </h2>
        <p className="mt-1 text-sm text-slate-600">
          Your feedback helps us improve future drafts.
        </p>

        <div className="mt-4 space-y-4">
          <div>
            <label
              htmlFor="feedback-reason"
              className="mb-1 block text-sm font-medium text-slate-700"
            >
              What went wrong?
            </label>
            <select
              id="feedback-reason"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:border-[#4B7F73] focus:outline-none focus:ring-1 focus:ring-[#4B7F73]"
            >
              <option value="">Select a reason</option>
              {REASON_OPTIONS.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label
              htmlFor="feedback-comments"
              className="mb-1 block text-sm font-medium text-slate-700"
            >
              Additional comments (optional)
            </label>
            <textarea
              id="feedback-comments"
              rows={4}
              value={comments}
              onChange={(e) => setComments(e.target.value)}
              placeholder="Tell us what went wrong…"
              className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:border-[#4B7F73] focus:outline-none focus:ring-1 focus:ring-[#4B7F73]"
            />
          </div>
        </div>

        <div className="mt-6 flex justify-end gap-2">
          <button
            type="button"
            onClick={onClose}
            className="rounded-lg border border-slate-300 px-3 py-1.5 text-sm text-slate-700 hover:bg-slate-50"
          >
            Skip
          </button>
          <button
            type="button"
            disabled={!reason || isSubmitting}
            onClick={() => onSubmit(reason, comments)}
            className="rounded-lg bg-[#4B7F73] px-3 py-1.5 text-sm font-medium text-white hover:bg-[#3F6C61] disabled:opacity-50"
          >
            {isSubmitting ? "Submitting…" : "Submit"}
          </button>
        </div>
      </div>
    </div>
  );
};
